module.exports = function ($searchRendering) {
    $searchRendering.on('click', '.search-rendering__filter-tag-close', function (e) {
        e.preventDefault();
        var $filterTag = $(e.target).closest('.search-rendering__filter-tag').first();
        var targetFilterId = '#' + $filterTag.data('type') + '-filtering-' + $filterTag.data('targetId');
        
        var prevFilterTag = $filterTag.prev('.search-rendering__filter-tag');
        var nextFilterTag = $filterTag.next('.search-rendering__filter-tag');
        if (prevFilterTag.length) {
            window.lastSearchRenderingFocusId = prevFilterTag.find('.search-rendering__filter-tag-close')[0].id;
        }
        else if (nextFilterTag.length) {
            window.lastSearchRenderingFocusId = nextFilterTag.find('.search-rendering__filter-tag-close')[0].id;
        }
        else {
            window.lastSearchRenderingFocusId = $(e.target).closest('.search-rendering').find('.search-rendering__filter-toggle').first()[0].id;
        }        

        window.ignoreFilterClickFocusChange = true;
        $(targetFilterId).click();        
    });    
};